module.exports = __webpack_public_path__ + "static/media/Apple SDGothicNeoSB00-01.b2a9bbf8.svg";